import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from '@/i18n'
import './style.css'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import { NODE_BASE } from '@/api/http'
import { useThemeStore } from '@/stores/themeStore'

const app = createApp(App)

app.config.globalProperties.$http = axios
app.config.globalProperties.$CryptoJS = CryptoJS
app.config.globalProperties.URL = NODE_BASE

app.use(createPinia())
useThemeStore().init()
app.use(router)
app.use(i18n)
app.mount('#app')
